import '@rce-web/ui-upgrade-dialog/dist/styles.css';

import { useAppSelector } from '@app/store';
import { getSlugFromPath } from '@hopin-team/dashboard-shared';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { ShareMenu } from '../../components/share-menu';
import { Layout } from '../../layout';
import { selectRecording } from '../../selector';
import { LabSnapshot } from './components/lab-snapshot';

const UpgradeBanner = () => {
  const { t } = useTranslation();
  const recording = useAppSelector(selectRecording);
  const slug = useMemo(() => getSlugFromPath(window.location.pathname), []);
  const choosePlanButtonHref = `/org/${slug}/manage/billing`;

  return (
    <Layout headerContextMenu={<ShareMenu />}>
      <div className="h-full w-full flex flex-col justify-between items-center text-white px-10 pt-10">
        <div className="flex flex-col items-center w-[24.5rem] gap-5 mt-24">
          <p className="text-2xl font-normal !m-0">
            {t('content-recording.unlock-creator-lab')}
          </p>
          <p className="text-[0.938rem] [line-height:1.25rem] text-center text-spring-neutral-b3">
            {t('content-recording.unlock-creator-lab-description')}
          </p>
          <Link
            to={choosePlanButtonHref}
            className={
              'h-9 rounded-[0.25rem] px-4 bg-spring-primary !text-spring-neutral-b0 font-medium text-[0.938rem] flex items-center justify-center'
            }
          >
            {t(`content-recording.choose-plan-now`)}
          </Link>
        </div>
        <LabSnapshot title={recording?.title} />
      </div>
    </Layout>
  );
};

export { UpgradeBanner };
